module.exports = __webpack_public_path__ + "img/9791185871745.869b95b2.jpg";